import { render, staticRenderFns } from "./SharedContentTable.vue?vue&type=template&id=022fc7da&scoped=true&"
import script from "./SharedContentTable.vue?vue&type=script&lang=js&"
export * from "./SharedContentTable.vue?vue&type=script&lang=js&"
import style0 from "./SharedContentTable.vue?vue&type=style&index=0&id=022fc7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fc7da",
  null
  
)

export default component.exports